import React, {useEffect, useState, useRef} from 'react';
import {useNavigate, useLocation} from 'react-router-dom';
import '../../App.css';
import '../create-json/CreateJson.css';
import '../default-configuration/DefaultConfiguration.css';
import {Button, MenuItem, Select} from "@mui/material";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";
import useAxiosPrivate from "../../context/useAxiosPrivate";

export const DefaultConfiguration = () => {
  const navigate = useNavigate();
  const [factories, setFactories] = useState(null);
  const [currentFactory, setCurrentFactory] = useState('');
  const [factoriesSelectOptions, setFactoriesSelectOptions] = useState('');
  const [defaultMaterialData, setDefaultMaterialData] = useState('');
  const [defaultMenuData, setDefaultMenuData] = useState('');
  const [defaultBundleInfoData, setDefaultBundleInfoData] = useState('');
  const axiosPrivate = useAxiosPrivate();


  useEffect(() => {
    getFactories();
  }, []);

  useEffect(() => {
    if (factories !== null) {
      getFactoriesSelectOptions()
    }

  }, [factories]);


  const getFactories = async () => {
    await axiosPrivate.get('/Users/Factory')
      .then((res) => {
        setFactories(res.data);
      })
      .catch( (e) => { console.log("getFactories error ", e) } );
  }

  const getDefaultConfiguration = () => {
    axiosPrivate.get(`/UserAdministration/GetDefaultConfiguration/${currentFactory}`)
      .then((res) => {
        const data = res.data;
        setDefaultMaterialData(JSON.stringify(data.material));
        setDefaultMenuData(JSON.stringify(data.menu));
        setDefaultBundleInfoData(JSON.stringify(data.bundleInfo));
      })
      .catch(e => {
        if (e.response.data.message === 'Конфигурация к заводу с таким id не найдена') {
          navigate('/add-json/default-configuration');
          setDefaultMaterialData('');
          setDefaultMenuData('');
          setDefaultBundleInfoData('');
        }
        alert(JSON.stringify(e.response.data.message));
      });
  };

  const transferDefaultConfiguration = () => {
    const transferData = {
      factoryId: JSON.parse(currentFactory),
      material: JSON.parse(defaultMaterialData),
      menu: JSON.parse(defaultMenuData),
      bundleInfo: JSON.parse(defaultBundleInfoData)
    }

    axiosPrivate.post(`/UserAdministration/DefaultConfiguration`, transferData)
      .then((res) => {
        alert("Конфигурация отправлена")
      })
      .catch(e => {
        alert(JSON.stringify(e.response.data.message));
      });
  }

  const getFactoriesSelectOptions = () => {
    const optionData = factories.map((factory) => {
      return <MenuItem key={factory.id} value={factory.id}>{`${factory.factory}`}</MenuItem>
    })
    setFactoriesSelectOptions(optionData); // form list of factories in dropdown menu
    setCurrentFactory(factories[0].id)
  }
  return (
    <>
      <div className="default-config">
        <div className="default-config__textarea-box">
          <label htmlFor="textarea-material">MATERIAL</label>
          <textarea
            wrap="soft"
            id="textarea-material"
            className="default-config__textarea"
            value={defaultMaterialData}
            onChange={(e) => setDefaultMaterialData(e.target.value)}
          ></textarea>

          <label htmlFor="textarea-menu">MENU</label>
          <textarea
            wrap="soft"
            id="textarea-menu"
            className="default-config__textarea"
            value={defaultMenuData}
            onChange={(e) => setDefaultMenuData(e.target.value)}
          ></textarea>

          <label htmlFor="textarea-bundle-info">BUNDLE INFO</label>
          <textarea
            wrap="soft"
            id="textarea-bundle-info"
            className="default-config__textarea"
            value={defaultBundleInfoData}
            onChange={(e) => setDefaultBundleInfoData(e.target.value)}
          ></textarea>
        </div>

        <div className="default-config__controls">
          <div className="select-container">
            <Select
              IconComponent={ExpandMoreOutlinedIcon}
              style={{backgroundColor: "white", width: "100%"}}
              MenuProps={{
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left"
                },
                transformOrigin: {
                  vertical: "top",
                  horizontal: "left"
                },
                PaperProps: {
                  sx: {
                    '& .MuiMenuItem-root': {fontSize: "1vw"}
                  }
                }
              }}
              sx={{
                '& .MuiInputBase-root': {borderRadius: "8px", border: "0.2vw solid grey", outline: "none"},
                '& .MuiSelect-select': {
                  backgroundColor: "white",
                  border: "none",
                  width: "100%",
                  fontSize: "1vw",
                  minHeight: "2vw",
                  lineHeight: "1",
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  overflow: "hidden",
                },
                '& .MuiInputBase-input': {padding: "0 3vw 0 0.5vw !important", width: "4vw"},
                '& .MuiSvgIcon-root': {position: "absolute", top: "calc(50% - 1.5vw)", right: "0", display: "flex", justifyContent: "center", alignItems: "center", fontSize: "3vw", backgroundColor: "white"},

              }}
              variant={"outlined"}
              autoWidth={true}
              value={currentFactory}
              onChange={(event) => {
                setCurrentFactory(event.target.value);
                }
              }
            >
              {factoriesSelectOptions}
            </Select>
          </div>

          <div className="default-config__button-group">
            <Button
              className='save-button'
              variant="outlined"
              onClick={() => getDefaultConfiguration()}
            >
              {"Получить базовую конфигурацию"}
            </Button>

            <Button
              className='save-button'
              variant="outlined"
              onClick={() => transferDefaultConfiguration()}
            >
              {"Отправить базовую конфигурацию"}
            </Button>
          </div>


          <div className="default-config__button-group">
            <Button
              className='save-button'
              variant="outlined"
              onClick={() => {navigate('/')}}
            >
              {"Вернуться на главную"}
            </Button>

            <Button
              className='save-button'
              variant="outlined"
              onClick={() => {navigate('/add-json')}}
            >
              {"Вернуться в конструктор"}
            </Button>
          </div>
        </div>
      </div>
    </>
  )
}